import * as React from 'react';
import cn from 'classnames';

import { useTheme } from '../../theme';
import { useConfig } from '../../context';

interface Props {
	isFullScreen?: boolean;
}

const SimpleLoader: React.FC<Props> = ({ isFullScreen = true }) => {
	const css = useTheme('SimpleLoader').SimpleLoaderStyles;

	const {
		Engine: { simpleLoaders }
	} = useConfig();

	const image = simpleLoaders?.[0]?.image;

	return (
		<div className={cn(css.wrapper, { [css.wrapper_fullScreen]: isFullScreen })} data-test-id="simple-loader">
			<div className={css.loader} style={image ? { backgroundImage: `url(${image})` } : undefined} />
		</div>
	);
};

export default SimpleLoader;
